import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const MessageIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2275 0C8.15254 0 0.727539 7.14583 0.727539 15.9688C0.727539 24.7917 8.15254 31.9375 17.2275 31.9375C19.1525 31.9375 21.1463 31.5729 23.0025 30.9167C23.2088 30.8438 23.4838 30.9167 23.6213 31.0625C24.9963 33.0312 27.1275 34.4167 29.465 35L29.8088 34.8542V34.4167C28.9084 33.1704 28.4437 31.6315 28.4938 30.0624C28.544 28.4932 29.1059 26.9912 30.0838 25.8125C32.215 23.1146 33.7275 19.6875 33.7275 15.9688C33.7275 7.14583 26.2338 0 17.2275 0ZM17.1588 7.58333C17.365 7.58333 17.5713 7.72917 17.64 7.94792L19.3588 13.125L24.6525 13.2708C24.8588 13.2708 25.065 13.4167 25.1338 13.5625C25.2025 13.7813 25.1338 14 24.9275 14.1458L20.7338 17.5L22.2463 22.75C22.315 22.9688 22.2463 23.1875 22.04 23.3333H21.49L17.1588 20.1979L12.8275 23.3333H12.2775C12.0713 23.1875 12.0025 22.9688 12.0713 22.75L13.5838 17.5L9.39004 14.1458C9.18379 14 9.11504 13.7813 9.18379 13.5625C9.25254 13.4167 9.45879 13.2708 9.66504 13.2708L14.9588 13.125L16.6775 7.94792C16.7463 7.72917 16.9525 7.58333 17.1588 7.58333Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default MessageIcon;

MessageIcon.propTypes = customIconsPropTypes;
